import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { IBrand } from "@faire/web-api/indigofair/data/IBrand";
export var brandIsRejected = function brandIsRejected() {
  var brand = getBrand();
  return (brand === null || brand === void 0 ? void 0 : brand.state) === IBrand.State.REJECTED_FOR_FRAUD || (brand === null || brand === void 0 ? void 0 : brand.state) === IBrand.State.REJECTED;
};